import { useRef, useState, useEffect } from 'react';
import { TooltipHost } from '@fluentui/react';
import { Row, Col } from 'react-bootstrap';

const Home = ({ contractName = "jojdf kasdh fklsjdh fskljdf sj  hsadl kfja shdfl kjhasdo", values = [19119191, 383838383, 84584848, 34848484, 3373773, 383883, 3848483] }) => {
  const rowRef = useRef(null);
  const [totalWidth, setTotalWidth] = useState(null);
  const [maxWidth, setMaxWidth] = useState(null);

  useEffect(() => {
    if (rowRef.current) {
      const rect = rowRef.current.getBoundingClientRect();
      setTotalWidth(rect.width);
    }
  }, []);

  useEffect(() => {
    if (totalWidth !== null) {
      setMaxWidth(totalWidth - (90 * 7));
    }
  }, [totalWidth]);

  const minWidth = contractName.length > 0 ? '75px' : 0;

  const renderContent = () => {
    if (maxWidth !== null) {
      if (contractName.length > 0) {
        if (maxWidth < minWidth) {
          return <div>{`${contractName.slice(0, 3)}...`}</div>;
        }
        if (contractName.length * 8 > maxWidth) {
          return <div>{`${contractName.slice(0, maxWidth / 8)}...`}</div>;
        }
        return <div>{contractName}</div>;
      }
    }
    return null;
  };

  return (
    <Row ref={rowRef}>
      <Col xs={2}>
        <TooltipHost
          content={contractName}
          onRenderContent={renderContent}
        >
          <div
            style={{
              maxWidth: `${maxWidth}px`,
              minWidth: minWidth,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}
          >
            {contractName}
          </div>
        </TooltipHost>
      </Col>
      {values.map((value, index) => (
        <Col key={index} xs={1}>
          {value}
        </Col>
      ))}
    </Row>
  );
};

export default Home